import { RadioButton } from 'components/1-atoms/RadioButton';
import { useState } from 'react';
import { ExciseDutyResult, formatCurrency } from '../ExciseDutyResult';
import styles from './DutySettings.module.scss';

export const WineDuty = () => {
	const [wineRate, setWineRate] = useState<string>(null);
	const [isSparkling, setIsSparkling] = useState<boolean>(null);
	const sparklingRate = 3.35;

	const calculator =
		wineRate && isSparkling !== null ? (ammount) => (Number(wineRate) + (isSparkling ? sparklingRate : 0)) * (ammount / 100) : null;
	const rateInfo =
		wineRate && isSparkling !== null
			? `Sats: ${formatCurrency(Number(wineRate))} kr. pr. liter${isSparkling ? ` + tillæg ${formatCurrency(sparklingRate)} pr. liter.` : '.'}`
			: null;

	return (
		<>
			<div className={styles.DutySettings}>
				<fieldset aria-labelledby="wineTypeHeading" onChange={(e) => setWineRate((e.target as HTMLInputElement).value)}>
					<h3 id="wineTypeHeading">Type vin</h3>
					<RadioButton id="lowAlcohol" value="5.18" name="alcoholVolume" label="Lav-alkohol vin (> 1,2% - 6%)" />
					<RadioButton id="tableWine" value="11.26" name="alcoholVolume" label="Bordvin (> 6% - 15%)" />
					<RadioButton id="fortifiedWine" value="15.08" name="alcoholVolume" label="Hedvin (> 15% - 22%)" />
				</fieldset>
				<fieldset aria-labelledby="sparklingHeader" onChange={(e) => setIsSparkling((e.target as HTMLInputElement).value === 'yes')}>
					<h3 id="sparklingHeader">Mousserende</h3>
					<RadioButton id="yes" value="yes" name="sparkling" label="Ja" />
					<RadioButton id="no" value="no" name="sparkling" label="Nej" />
				</fieldset>
			</div>
			<ExciseDutyResult unit="cl" container="Flasker" calculator={calculator} rateInfo={rateInfo} />
		</>
	);
};
